<template>
  <div>
    <ejs-dialog
        ref="agencySettingPopup"
        header="대행사 설정"
        :allowDragging="true"
        :showCloseIcon="true"
        :width="800"
        height="595"
        :animationSettings="{ effect: 'None' }"
        :isModal="true"
        @close="onPopupClosed"
    >
      <div class="window">
        <div class="windowContent">
          <div class="content-wrapper">
            <div class="content-body">
              <article class="body-article">
                <section class="article-section">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">대행사 설정 목록</div>
                    </div>
                    <div class="header-right">
                      <ul class="header-button">
                        <li class="add">
                          <erp-button
                              button-div="SAVE"
                              :is-icon-custom="true"
                              @click.native="onAddButtonClicked"
                          >
                            추가
                          </erp-button>
                        </li>
                        <li class="add">
                          <erp-button
                              button-div="SAVE"
                              :is-icon-custom="true"
                              @click.native="onAllAddButtonClicked"
                          >
                            전체추가
                          </erp-button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="section-body">
                    <ejs-grid-wrapper
                        ref="grid"
                        v-bind="gridProps"
                        :dataSource="agencys"
                        @headerCellInfo="onGridHeaderCellInfo"
                        @queryCellInfo="onGridQueryCellInfo"
                        @visitEjsDropdownListEditTemplateChanged="onGridDropdownListEditChanged"
                    />
                  </div>
                </section>
              </article>
            </div>
          </div>
        </div>
        <div class="windowFooter">
          <div class="lookup-condition">
            <ul class="button">
              <li class="delete">
                <erp-button
                    button-div="SAVE"
                    :is-icon-custom="true"
                    :disabled="!isAgencyOpenTimes"
                    @click.native="onAgencyDeleteButtonClicked"
                >
                  대행사 제거
                </erp-button>
              </li>
            </ul>
          </div>
          <ul class="button">
            <li class="keyColor confirm">
              <erp-button
                  button-div="SAVE"
                  :is-icon-custom="true"
                  :is-shortcut-button="true"
                  @click.native="onSaveButtonClicked"
              >
                저장
              </erp-button>
            </li>
            <li class="close">
              <erp-button
                  button-div="CLOSE"
                  @click.native="onCloseButtonClicked"
              >
                닫기
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<style scoped>
body .window .windowContent .article-section .section-body {overflow: visible; border: none;}
</style>

<script>
import ErpButton from "@/components/button/ErpButton.vue";
import commonMixin from "@/views/layout/mixin/commonMixin";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";

import EjsGridWrapper from "@/components/common/EjsGridWrapper";
import gridVisitEjsDropdownlistEditTemplate from "@/components/common/gridTemplate/GridVisitEjsDropdownlistEditTemplate";

import {
  Edit,
  ForeignKey,
} from '@syncfusion/ej2-vue-grids';

import {
  commonCodesGetCommonCode,
  commonCodeGetComCodeDefaultValue,
  commonCodesGetCommonCodeByIdxAttrb,
} from "@/utils/commonCodes";
import GolfErpAPI from "@/api/v2/GolfErpAPI";
import _groupBy from "lodash/groupBy";
import Vue from "vue";

export default {
  name: "AgencySettingPopup",
  mixins: [commonMixin, confirmDialogMixin],
  components: {
    EjsGridWrapper,
    ErpButton
  },
  data() {
    return {
      gridVisitEjsDropdownlistEditTemplateEventBus: new Vue(),
      agencyCodes: commonCodesGetCommonCodeByIdxAttrb("RESVE_CHANNEL", 2, "AGENT").filter(commonCode => commonCode.useFlag),
      agencys: [],
      timeIds: [],
      bsnCode: null,
      bsnDate: null,
      isSaved: false,
      isAgencyOpenTimes: false,
      isSelfTime: false,
    };
  },
  computed: {
    gridProps() {
      return {
        provides: [
          Edit,
          ForeignKey,
        ],
        allowFiltering: false,
        allowSorting: false,
        validationModification: false,
        editSettings: {
          allowEditing: true,
          allowAdding: true,
          allowDeleting: false,
          mode: "Batch",
          showConfirmDialog: false,
          newRowPosition: "Bottom",
        },
        selectionSettings: {
          type: "Single",
          mode: "Both",
          enableToggle: false,
          persistSelection: false,
        },
        columns: [
          {
            field: "resveChannel",
            headerText: "대행사",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            editTemplate: () =>
                gridVisitEjsDropdownlistEditTemplate(
                    "resveChannel",
                    this.agencyCodes,
                    this.$refs.grid,
                    this.gridVisitEjsDropdownlistEditTemplateEventBus
                ),
          },
          {
            field: "perOption",
            headerText: "인원옵션",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            groupCode: "PER_OPTION",
            allowEditing: false,
          },
          {
            field: "setleOption",
            headerText: "결제옵션",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            groupCode: "SETLE_OPTION",
            allowEditing: false,
            visible: false,
          },
          {
            field: "norPaymtCode",
            headerText: "정상그린피",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            groupCode: "PAYMT_CODE",
            isDropdowneditInit: true,
            dropdowneditInitValue: "",
            allowEditing: true,
          },
          {
            field: "dcPaymtCode",
            headerText: "할인그린피",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            groupCode: "PAYMT_CODE",
            editTemplate: () =>
                gridVisitEjsDropdownlistEditTemplate(
                    "dcPaymtCode",
                    commonCodesGetCommonCode("PAYMT_CODE", true),
                    this.$refs.grid,
                    this.gridVisitEjsDropdownlistEditTemplateEventBus
                ),
            allowEditing: true,
          },
          {
            field: "purcPaymtCode",
            headerText: "매입가",
            type: "string",
            minWidth: 16,
            width: 90,
            editType: "dropdownedit",
            isCommonCodeField: true,
            groupCode: "PAYMT_CODE",
            allowEditing: false,
            visible: false,
          },
        ],
      };
    },
  },
  created() {
    this.agencyCodes.unshift({
      comCode: "",
      comName: "",
    });
  },
  methods: {
    async showPopup(args) {
      this.timeIds = args.timeIds;
      this.isAgencyOpenTimes = args.isAgencyOpenTimes;
      this.bsnDate = args.bsnDate;
      this.bsnCode = args.bsnCode;

      if (this.timeIds.length === 1 && this.isAgencyOpenTimes) {
        this.agencys = await GolfErpAPI.fetchAgencyByTimeId(this.timeIds[0]);
      }
    },
    onPopupClosed() {
      this.$emit("popupClosed", {
        isReload: this.isSaved,
        timeId: this.timeIds.length === 1 ? this.timeIds[0] : null // 한개 타임을 선택했을 경우 타임ID를 넘겨준다(RowSelect하기 위함)
      });
    },
    onCloseButtonClicked() {
      this.$refs.agencySettingPopup.hide();
    },
    onAddButtonClicked() {
      this.$refs.grid.addRecord({
        perOption: commonCodeGetComCodeDefaultValue("PER_OPTION"),
        setleOption: commonCodeGetComCodeDefaultValue("SETLE_OPTION"),
      });
    },
    async onAllAddButtonClicked() {
      // 정상그린피, 할인그린피, 매입가 항목에 비회원 특전의 셀프요금을 기본 값으로 셋팅
      const membershipGrpPaymt = await GolfErpAPI.fetchMembershipGrpPaymt({
        bsnCode: this.bsnCode,
        benTrget: "MEMBER",
        memberGrade: "NOR",
      });

      const paymtCode = (this.isSelfTime ? membershipGrpPaymt.paymtCodeSelf : membershipGrpPaymt.paymtCode) || null;

      const gridData = this.$refs.grid.getBatchCurrentViewRecords().filter(item => item.resveChannel);

      const allAgencys =
          this.agencyCodes
              .filter(item =>
                  // data 배열에 없는 item.comCode만 필터링
                  !gridData.some(dataItem => dataItem.resveChannel === item.comCode) &&
                  item.comCode
              ).map(item => {
            return {
              resveChannel: item.comCode,
              perOption: commonCodeGetComCodeDefaultValue("PER_OPTION"),
              setleOption: commonCodeGetComCodeDefaultValue("SETLE_OPTION"),
              norPaymtCode: paymtCode,
              dcPaymtCode: paymtCode,
              purcPaymtCode: paymtCode,
            };
          });


      // 대행사 셋팅 및 대행사별 요금 셋팅
      if (allAgencys.length > 0) {
        for (const item of allAgencys) {
          const data = await GolfErpAPI.fetchAgencyMemberGradeGrpPaymt({
            agncyCode: item.resveChannel,
            bsnDate: this.bsnDate,
            benTrget: "MEMBER",
          });

          const paymtCode = this.isSelfTime ? data.paymtCodeSelf : data.paymtCode;

          this.$refs.grid.addRecord({
            resveChannel: item.resveChannel,
            perOption: commonCodeGetComCodeDefaultValue("PER_OPTION"),
            setleOption: commonCodeGetComCodeDefaultValue("SETLE_OPTION"),
            norPaymtCode: paymtCode,
            dcPaymtCode: paymtCode,
            purcPaymtCode: paymtCode,
          });
        }
      }

    },
    async onSaveButtonClicked() {
      if (!this.$refs.grid.validate()) {
        return;
      }

      if (!(await this.confirm("저장하시겠습니까?"))) {
        return;
      }

      const data = this.$refs.grid.getBatchCurrentViewRecords().filter(item => item.resveChannel);

      if (!(this.timeIds.length > 0)) {
        this.errorToast("선택된 타임이 없습니다");
        return;
      }

      if (!(data.length > 0)) {
        this.errorToast("대행사 설정이 없습니다");
        return;
      }

      if (Object.values(_groupBy(data, "resveChannel")).filter(item => item.length > 1).length > 0) {
        this.errorToast("대행사는 중복하여 등록하실 수 없습니다");
        return;
      }

      await GolfErpAPI.reservationTimeAgencySetting({
        timeIds: this.timeIds,
        tgResveChannels: data,
      });

      this.infoToast("저장되었습니다");
      this.isSaved = true;

      this.onCloseButtonClicked();
    },
    async onAgencyDeleteButtonClicked() {
      if (!(await this.confirm("선택된 타임들의 대행사 설정이 제거됩니다.<br>진행하시겠습니까?"))) {
        return;
      }

      await GolfErpAPI.reservationTimeAgencyDelete(this.timeIds);

      this.infoToast("삭제되었습니다");
      this.isSaved = true;

      this.onCloseButtonClicked();
    },
    onGridHeaderCellInfo(args) {
      const {
        cell: {
          column: {
            field
          },
        },
        node: {
          classList
        },
      } = args;

      if (field === "resveChannel") {
        classList.add(this.$t("className.grid.requiredInputHeader"));
      } else if (field === "norPaymtCode") {
        args.node.addEventListener("dblclick", this.gridHeaderNorPaymtCodeDoubleClicked, false);
      } else if (field === "dcPaymtCode") {
        args.node.addEventListener("dblclick", this.gridHeaderDcPaymtCodeDoubleClicked, false);
      } else if (field === "purcPaymtCode") {
        args.node.addEventListener("dblclick", this.gridHeaderPurcPaymtCodeDoubleClicked, false);
      }
    },
    onGridQueryCellInfo(args) {
      const {
        column: {
          allowEditing,
        },
        cell: {
          classList,
        },
      } = args;

      if (allowEditing) {
        classList.add(this.$t("className.grid.modifyArea"));
      }
    },
    gridHeaderNorPaymtCodeDoubleClicked() {
      const viewRecords = this.$refs.grid.getBatchCurrentViewRecords();

      if (viewRecords.length > 0) {
        const paymtCode = viewRecords[0].norPaymtCode;

        viewRecords.forEach(async (data, idx) => {
          this.$refs.grid.updateCell(idx, "norPaymtCode", paymtCode);
        });
      }
    },
    gridHeaderDcPaymtCodeDoubleClicked() {
      const viewRecords = this.$refs.grid.getBatchCurrentViewRecords();

      if (viewRecords.length > 0) {
        const paymtCode = viewRecords[0].dcPaymtCode;

        viewRecords.forEach(async (data, idx) => {
          this.$refs.grid.updateCell(idx, "dcPaymtCode", paymtCode);
        });
      }
    },
    gridHeaderPurcPaymtCodeDoubleClicked() {
      const viewRecords = this.$refs.grid.getBatchCurrentViewRecords();

      if (viewRecords.length > 0) {
        const paymtCode = viewRecords[0].purcPaymtCode;

        viewRecords.forEach(async (data, idx) => {
          this.$refs.grid.updateCell(idx, "purcPaymtCode", paymtCode);
        });
      }
    },
    async onGridDropdownListEditChanged(args) {
      const {columnName, value, rowIndex,} = args;

      if (columnName === "dcPaymtCode") {
        this.$refs.grid.updateCell(rowIndex, "purcPaymtCode", value);
      } else if (columnName === "resveChannel" && value) {
        const data = await GolfErpAPI.fetchAgencyMemberGradeGrpPaymt({
          agncyCode: value,
          bsnDate: this.bsnDate,
          benTrget: "MEMBER",
        });

        const paymtCode = this.isSelfTime ? data.paymtCodeSelf : data.paymtCode;
        this.$refs.grid.updateCell(rowIndex, "norPaymtCode", paymtCode);
        this.$refs.grid.updateCell(rowIndex, "dcPaymtCode", paymtCode);
        this.$refs.grid.updateCell(rowIndex, "purcPaymtCode", paymtCode);
      }
    },
  },
};
</script>
